/* eslint-disable react/react-in-jsx-scope */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import moment from 'moment-timezone';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import { DayContainer, Day } from './styled';
import { type DaysProps } from '../../../common/types';
import { localMidnight } from '../../../common/utils';

export function Days({ startDate, timezone, days, dateFormat = 'dd D/MM', locale }: DaysProps) {
	const localStartDate = localMidnight(startDate, timezone);

	const dayComponents = Array.from({ length: days }, (_, k) => {
		const dateWithLocale = locale ? moment(localStartDate).locale(locale) : moment(localStartDate);
		const dateLabel = dateWithLocale.add(k, 'days').format(dateFormat);

		return (
			<Day
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				css={css({
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
					width: `${100 / days}%`,
				})}
				key={dateLabel}
			>
				{dateLabel}
			</Day>
		);
	});
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
	return <DayContainer className="days">{dayComponents}</DayContainer>;
}

export default Days;
